import { createElementObject, createPathComponent, extendContext, updateCircle } from './core';
import L from '@anlan/gs-map';
import type { CircleProps, LeafletContextInterface } from './core';
const LeafletCircle = L.Circle;
export const Circle = createPathComponent(function createCircle({ center, children, ...options }: CircleProps, ctx: LeafletContextInterface) {
    void children;
    const circle = new LeafletCircle(center, options);
    return createElementObject(circle, extendContext(ctx, {
        overlayContainer: circle
    }));
}, updateCircle);
